<template>
  <Modal
    :show="show"
    @close="close()"
  >
    Username:
    <input
      v-model="username"
      class="form-control"
      placeholder="email"
      @keyup.enter="login"
    >
  </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'

export default {
  name: 'WidgetAdmin',
  components: {
    Modal
  },
  extends: Modal,
  props: ['show'],
  data () {
    return {
      username: ''
    }
  },
  methods: {
    login: function () {
      this.$store.dispatch('getToken', this.username)
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
